/* ============================================================
   ARGOING REV18 blocco 7 — Dati per la fattura (carrello + cassetto)
   assets/argoing-fattura.js
   - Validazione formale Codice fiscale (16 car., carattere di controllo,
     omocodia) e Partita IVA (11 cifre, carattere di controllo).
   - Salvataggio come attributi dell'ordine via POST /cart/update.js.
   - Blocco del pulsante «Vai al pagamento» finché i dati non sono validi.
   - Memoria locale (localStorage ag_fatt) e precompilazione da customer.
   Nessuna dipendenza esterna. Funziona anche senza jQuery.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  root.ArgoingFattura = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { api.init(); });
    } else { api.init(); }
  }
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  /* ---------------- Algoritmi di controllo ---------------- */

  var CF_PARI = {};   // valore per posizione pari
  var CF_DISPARI = {}; // valore per posizione dispari
  (function () {
    var i, c;
    for (i = 0; i < 10; i++) { CF_PARI[String(i)] = i; }
    for (i = 0; i < 26; i++) { CF_PARI[String.fromCharCode(65 + i)] = i; }
    var disp = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
    for (i = 0; i < 26; i++) { CF_DISPARI[String.fromCharCode(65 + i)] = disp[i]; }
    for (i = 0; i < 10; i++) { CF_DISPARI[String(i)] = disp[i]; }
    c = null;
  }());

  // Omocodia: nelle posizioni numeriche le cifre possono essere sostituite da lettere
  var CF_OMO = { L: '0', M: '1', N: '2', P: '3', Q: '4', R: '5', S: '6', T: '7', U: '8', V: '9' };
  var CF_NUM = '[0-9LMNPQRSTUV]';
  var CF_RE = new RegExp('^[A-Z]{6}' + CF_NUM + '{2}[ABCDEHLMPRST]' + CF_NUM + '{2}[A-Z]' + CF_NUM + '{3}[A-Z]$');

  function normalizzaCF(v) { return String(v || '').toUpperCase().replace(/[\s.\-]/g, ''); }

  function cfCarattereControllo(primi15) {
    var somma = 0;
    for (var i = 0; i < 15; i++) {
      var ch = primi15.charAt(i);
      // posizioni 1,3,5,... (indice 0,2,4,...) sono DISPARI
      somma += (i % 2 === 0) ? CF_DISPARI[ch] : CF_PARI[ch];
    }
    return String.fromCharCode(65 + (somma % 26));
  }

  // Ritorna {ok:true} oppure {ok:false, errore:'…'}
  function verificaCodiceFiscale(valore) {
    var cf = normalizzaCF(valore);
    if (!cf) { return { ok: false, errore: 'Inserisci il codice fiscale' }; }
    if (/^[0-9]{11}$/.test(cf)) { return { ok: false, errore: 'Hai inserito una partita IVA: per un privato serve il codice fiscale di 16 caratteri' }; }
    if (cf.length !== 16) { return { ok: false, errore: 'Il codice fiscale deve avere 16 caratteri (ne hai inseriti ' + cf.length + ')' }; }
    if (!CF_RE.test(cf)) { return { ok: false, errore: 'Formato non corretto: ricontrolla lettere e cifre nelle posizioni giuste' }; }
    // mese valido
    var mesi = 'ABCDEHLMPRST';
    if (mesi.indexOf(cf.charAt(8)) < 0) { return { ok: false, errore: 'La lettera del mese di nascita non è valida' }; }
    // giorno 1-31 (F) o 41-71 (M), tenendo conto dell'omocodia
    var gg = cf.substr(9, 2).replace(/[LMNPQRSTUV]/g, function (c) { return CF_OMO[c]; });
    var g = parseInt(gg, 10);
    if (!((g >= 1 && g <= 31) || (g >= 41 && g <= 71))) { return { ok: false, errore: 'Il giorno di nascita non è valido' }; }
    if (cfCarattereControllo(cf.substr(0, 15)) !== cf.charAt(15)) {
      return { ok: false, errore: 'Carattere di controllo non valido: ricontrolla il codice fiscale' };
    }
    return { ok: true, valore: cf };
  }

  function normalizzaPIVA(v) { return String(v || '').replace(/[\s.\-]/g, '').replace(/^IT/i, ''); }

  function pivaCifraControllo(primi10) {
    var somma = 0;
    for (var i = 0; i < 10; i++) {
      var d = parseInt(primi10.charAt(i), 10);
      if (i % 2 === 0) { somma += d; } // posizioni dispari (1ª, 3ª, …)
      else { d = d * 2; if (d > 9) { d -= 9; } somma += d; }
    }
    return String((10 - (somma % 10)) % 10);
  }

  function verificaPartitaIVA(valore) {
    var p = normalizzaPIVA(valore);
    if (!p) { return { ok: false, errore: 'Inserisci la partita IVA' }; }
    if (!/^[0-9]+$/.test(p)) { return { ok: false, errore: 'La partita IVA contiene solo cifre (senza IT davanti)' }; }
    if (p.length !== 11) { return { ok: false, errore: 'La partita IVA deve avere 11 cifre (ne hai inserite ' + p.length + ')' }; }
    if (/^0{11}$/.test(p)) { return { ok: false, errore: 'La partita IVA non può essere tutta zeri' }; }
    if (pivaCifraControllo(p.substr(0, 10)) !== p.charAt(10)) {
      return { ok: false, errore: 'Carattere di controllo non valido: ricontrolla la partita IVA' };
    }
    return { ok: true, valore: p };
  }

  function verificaCellulare(prefisso, numero) {
    var pre = String(prefisso || '+39').replace(/\s/g, '');
    var n = String(numero || '').replace(/[\s.\-\/]/g, '');
    if (!n) { return { ok: false, errore: 'Inserisci il numero di cellulare' }; }
    // se l'utente scrive il prefisso anche nel numero, lo togliamo
    if (pre === '+39' && /^(\+39|0039)/.test(n)) { n = n.replace(/^(\+39|0039)/, ''); }
    if (!/^[0-9]+$/.test(n)) { return { ok: false, errore: 'Il cellulare contiene solo cifre' }; }
    if (n.length < 9 || n.length > 10) { return { ok: false, errore: 'Il cellulare deve avere 9 o 10 cifre (ne hai inserite ' + n.length + ')' }; }
    if (pre === '+39' && n.charAt(0) !== '3') { return { ok: false, errore: 'Un cellulare italiano inizia con 3: per un numero fisso usa un altro recapito' }; }
    return { ok: true, valore: pre + ' ' + n };
  }

  function verificaSDI(valore) {
    var s = String(valore || '').toUpperCase().replace(/\s/g, '');
    if (!s) { return { ok: true, vuoto: true, valore: '' }; }
    if (s.length !== 7) { return { ok: false, errore: 'Il codice destinatario SDI ha 7 caratteri (ne hai inseriti ' + s.length + ')' }; }
    if (!/^[A-Z0-9]{7}$/.test(s)) { return { ok: false, errore: 'Il codice SDI contiene solo lettere e cifre' }; }
    return { ok: true, valore: s };
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  function verificaPEC(valore) {
    var e = String(valore || '').trim().toLowerCase();
    if (!e) { return { ok: true, vuoto: true, valore: '' }; }
    if (!EMAIL_RE.test(e)) { return { ok: false, errore: 'Indirizzo PEC non valido: controlla la chiocciola e il dominio' }; }
    return { ok: true, valore: e };
  }

  function verificaRagioneSociale(valore) {
    var r = String(valore || '').trim().replace(/\s+/g, ' ');
    if (!r) { return { ok: false, errore: 'Inserisci la ragione sociale' }; }
    if (r.length < 2) { return { ok: false, errore: 'La ragione sociale è troppo corta' }; }
    return { ok: true, valore: r };
  }

  /* Valida l'intero stato. Ritorna {ok, errori:{campo:msg}, mancanti:[etichette], attributi:{…}} */
  var ETICHETTE = {
    tipo: 'Tipo cliente', cf: 'Codice fiscale', rs: 'Ragione sociale', piva: 'Partita IVA',
    sdi: 'Codice SDI', pec: 'PEC', cell: 'Cellulare', sdipec: 'Codice SDI o PEC'
  };

  function validaStato(s) {
    var errori = {}, mancanti = [], attr = {
      'Tipo cliente': '', 'Codice fiscale': '', 'Ragione sociale': '', 'Partita IVA': '',
      'Codice SDI': '', 'PEC': '', 'Cellulare fattura': ''
    };
    var r;
    if (s.tipo !== 'privato' && s.tipo !== 'azienda') {
      mancanti.push('scegliere Privato o Azienda');
      return { ok: false, errori: errori, mancanti: mancanti, attributi: attr };
    }
    attr['Tipo cliente'] = s.tipo === 'privato' ? 'Privato' : 'Azienda';
    if (s.tipo === 'privato') {
      r = verificaCodiceFiscale(s.cf);
      if (!r.ok) { errori.cf = r.errore; mancanti.push(ETICHETTE.cf); } else { attr['Codice fiscale'] = r.valore; }
    } else {
      r = verificaRagioneSociale(s.rs);
      if (!r.ok) { errori.rs = r.errore; mancanti.push(ETICHETTE.rs); } else { attr['Ragione sociale'] = r.valore; }
      r = verificaPartitaIVA(s.piva);
      if (!r.ok) { errori.piva = r.errore; mancanti.push(ETICHETTE.piva); } else { attr['Partita IVA'] = r.valore; }
      var rs = verificaSDI(s.sdi), rp = verificaPEC(s.pec);
      if (!rs.ok) { errori.sdi = rs.errore; }
      if (!rp.ok) { errori.pec = rp.errore; }
      if (rs.ok && rp.ok && rs.vuoto && rp.vuoto) {
        errori.sdipec = 'Serve almeno uno tra codice destinatario SDI e PEC';
        mancanti.push(ETICHETTE.sdipec);
      } else if (!rs.ok || !rp.ok) {
        mancanti.push(ETICHETTE.sdipec);
      } else {
        attr['Codice SDI'] = rs.valore; attr['PEC'] = rp.valore;
        if (rs.vuoto && !rp.vuoto) { attr['Codice SDI'] = '0000000'; }
      }
    }
    r = verificaCellulare(s.pre, s.cell);
    if (!r.ok) { errori.cell = r.errore; mancanti.push(ETICHETTE.cell); } else { attr['Cellulare fattura'] = r.valore; }
    return { ok: mancanti.length === 0, errori: errori, mancanti: mancanti, attributi: attr };
  }

  /* ---------------- Parte DOM ---------------- */

  var LS_KEY = 'ag_fatt';
  var stato = { tipo: '', cf: '', rs: '', piva: '', sdi: '', pec: '', pre: '+39', cell: '' };
  var toccati = {}; // campi su cui l'utente ha già scritto: mostriamo errori solo lì
  var istanze = [];
  var ultimoSalvato = '';
  var salvataggioInCorso = null;
  var timerSalva = null;
  var cfg = { cartUpdateUrl: '/cart/update.js', cartUrl: '/cart' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function leggiLS() {
    try { var v = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); return (v && typeof v === 'object') ? v : null; } catch (e) { return null; }
  }
  function scriviLS() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(stato)); } catch (e) { /* privato / bloccato: ignoriamo */ }
  }

  function leggiDatiServer(root) {
    // <script type="application/json" data-ag-fatt-dati> con customer e cart.attributes (dal Liquid)
    var el = $('[data-ag-fatt-dati]', root) || $('[data-ag-fatt-dati]');
    if (!el) { return {}; }
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  function statoDaAttributi(a) {
    if (!a || !a['Tipo cliente']) { return null; }
    var cellulare = String(a['Cellulare fattura'] || '');
    var m = cellulare.match(/^(\+\d{1,3})\s*(\d+)$/);
    return {
      tipo: /azienda/i.test(a['Tipo cliente']) ? 'azienda' : 'privato',
      cf: a['Codice fiscale'] || '', rs: a['Ragione sociale'] || '', piva: a['Partita IVA'] || '',
      sdi: (a['Codice SDI'] === '0000000' ? '' : (a['Codice SDI'] || '')), pec: a['PEC'] || '',
      pre: m ? m[1] : '+39', cell: m ? m[2] : cellulare.replace(/\D/g, '')
    };
  }

  function creaIstanza(root) {
    var ist = { root: root, campi: {}, errori: {}, mode: root.getAttribute('data-mode') || 'page' };
    $$('[data-ag-campo]', root).forEach(function (el) {
      var k = el.getAttribute('data-ag-campo');
      ist.campi[k] = el;
      var err = root.querySelector('[data-ag-errore="' + k + '"]');
      if (err) { ist.errori[k] = err; }
    });
    ist.errori.sdipec = root.querySelector('[data-ag-errore="sdipec"]');
    ist.tipoBtn = $$('[data-ag-tipo]', root);
    ist.panPrivato = $('[data-ag-pannello="privato"]', root);
    ist.panAzienda = $('[data-ag-pannello="azienda"]', root);
    ist.riepilogo = $('[data-ag-riepilogo]', root);
    ist.statoRiga = $('[data-ag-stato]', root);
    return ist;
  }

  function popolaIstanza(ist) {
    Object.keys(ist.campi).forEach(function (k) {
      var el = ist.campi[k];
      if (document.activeElement === el) { return; }
      if (el.value !== (stato[k] || '')) { el.value = stato[k] || ''; }
    });
    ist.tipoBtn.forEach(function (b) {
      var on = b.getAttribute('data-ag-tipo') === stato.tipo;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', (on || !stato.tipo) ? '0' : '-1');
    });
    if (ist.panPrivato) { ist.panPrivato.hidden = stato.tipo !== 'privato'; }
    if (ist.panAzienda) { ist.panAzienda.hidden = stato.tipo !== 'azienda'; }
    ist.root.setAttribute('data-tipo', stato.tipo || 'nessuno');
  }

  function mostraErrori(ist, ris) {
    Object.keys(ist.errori).forEach(function (k) {
      var box = ist.errori[k]; if (!box) { return; }
      var msg = ris.errori[k];
      var campo = ist.campi[k];
      var visibile = !!msg && (toccati[k] || toccati._tutti || (k === 'sdipec' && (toccati.sdi || toccati.pec)));
      box.textContent = visibile ? msg : '';
      box.hidden = !visibile;
      if (campo) {
        campo.setAttribute('aria-invalid', visibile ? 'true' : 'false');
        campo.closest('.agF-campo') && campo.closest('.agF-campo').classList.toggle('has-errore', visibile);
      }
    });
    if (ist.campi.sdi && ist.campi.pec) {
      var grp = ist.root.querySelector('[data-ag-gruppo="sdipec"]');
      if (grp) { grp.classList.toggle('has-errore', !!ris.errori.sdipec && (toccati.sdi || toccati.pec || toccati._tutti)); }
    }
  }

  function aggiornaStatoRiga(ist, ris) {
    if (!ist.statoRiga) { return; }
    if (ris.ok) {
      ist.statoRiga.className = 'agF-stato is-ok';
      ist.statoRiga.innerHTML = '<svg class="agF-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span>Dati per la fattura completi: puoi andare al pagamento</span>';
    } else {
      ist.statoRiga.className = 'agF-stato is-manca';
      ist.statoRiga.innerHTML = '<svg class="agF-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg><span>Per proseguire servono: <b>' + ris.mancanti.join(', ') + '</b></span>';
    }
  }

  /* Pulsanti di checkout nel documento: disattivati finché non è valido */
  function pulsantiCheckout() {
    return $$('button[name="checkout"], input[name="checkout"], [data-ag-checkout-btn]');
  }

  function aggiornaPulsanti(ris) {
    pulsantiCheckout().forEach(function (b) {
      b.disabled = !ris.ok;
      b.setAttribute('aria-disabled', ris.ok ? 'false' : 'true');
      b.classList.toggle('agF-bloccato', !ris.ok);
      if (!ris.ok) {
        if (!b.hasAttribute('data-ag-title-orig')) { b.setAttribute('data-ag-title-orig', b.getAttribute('title') || ''); }
        b.setAttribute('title', 'Completa prima i dati per la fattura');
      } else if (b.hasAttribute('data-ag-title-orig')) {
        var t = b.getAttribute('data-ag-title-orig');
        if (t) { b.setAttribute('title', t); } else { b.removeAttribute('title'); }
      }
    });
  }

  function salvaAttributi(attr) {
    var firma = JSON.stringify(attr);
    if (firma === ultimoSalvato) { return Promise.resolve(true); }
    var corpo = JSON.stringify({ attributes: attr });
    var p = fetch(cfg.cartUpdateUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: corpo
    }).then(function (r) {
      if (!r.ok) { throw new Error('HTTP ' + r.status); }
      ultimoSalvato = firma;
      document.dispatchEvent(new CustomEvent('argoing:fattura:salvata', { detail: { attributi: attr } }));
      return true;
    }).catch(function (e) {
      // non blocchiamo il cliente: al submit riproviamo
      if (root_console()) { root_console().warn('[argoing-fattura] salvataggio attributi fallito', e); }
      return false;
    });
    salvataggioInCorso = p;
    return p;
  }
  function root_console() { return (typeof console !== 'undefined') ? console : null; }

  var ultimoRisultato = null;

  function aggiorna(origine) {
    var ris = validaStato(stato);
    ultimoRisultato = ris;
    istanze.forEach(function (ist) {
      if (ist !== origine) { popolaIstanza(ist); } else {
        ist.tipoBtn.forEach(function (b) {
          var on = b.getAttribute('data-ag-tipo') === stato.tipo;
          b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.setAttribute('tabindex', (on || !stato.tipo) ? '0' : '-1');
        });
        if (ist.panPrivato) { ist.panPrivato.hidden = stato.tipo !== 'privato'; }
        if (ist.panAzienda) { ist.panAzienda.hidden = stato.tipo !== 'azienda'; }
        ist.root.setAttribute('data-tipo', stato.tipo || 'nessuno');
      }
      mostraErrori(ist, ris);
      aggiornaStatoRiga(ist, ris);
      ist.root.classList.toggle('is-valido', ris.ok);
    });
    aggiornaPulsanti(ris);
    scriviLS();
    clearTimeout(timerSalva);
    if (ris.ok) {
      timerSalva = setTimeout(function () { salvaAttributi(ris.attributi); }, 350);
    }
    return ris;
  }

  function collegaIstanza(ist) {
    ist.tipoBtn.forEach(function (b) {
      b.addEventListener('click', function () {
        stato.tipo = b.getAttribute('data-ag-tipo');
        toccati.tipo = true;
        aggiorna(ist);
        // porta il focus sul primo campo del pannello scelto
        var pan = stato.tipo === 'privato' ? ist.panPrivato : ist.panAzienda;
        var primo = pan && pan.querySelector('input');
        if (primo && ist.mode === 'page') { primo.focus(); }
      });
      b.addEventListener('keydown', function (e) {
        // radiogroup: frecce per spostarsi
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var idx = ist.tipoBtn.indexOf(b);
          var next = ist.tipoBtn[(idx + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : ist.tipoBtn.length - 1)) % ist.tipoBtn.length];
          next.focus(); next.click();
        }
      });
    });
    Object.keys(ist.campi).forEach(function (k) {
      var el = ist.campi[k];
      el.addEventListener('input', function () {
        var v = el.value;
        if (k === 'cf' || k === 'sdi') { v = v.toUpperCase(); if (el.value !== v) { el.value = v; } }
        if (k === 'piva' || k === 'cell') { v = v.replace(/[^\d\s+]/g, ''); if (el.value !== v) { el.value = v; } }
        stato[k] = v;
        aggiorna(ist);
      });
      el.addEventListener('blur', function () {
        toccati[k] = true;
        stato[k] = el.value;
        aggiorna(ist);
      });
    });
  }

  /* Sposta il blocco pagina dentro il form carrello, prima del pulsante checkout (se c'è) */
  function posizionaNelCarrello(root) {
    if (root.getAttribute('data-mode') !== 'page') { return; }
    if (root.hasAttribute('data-ag-no-move')) { return; }
    var ancora = $('[data-ag-fattura-anchor]');
    if (ancora) { ancora.parentNode.insertBefore(root, ancora); return; }
    var forms = $$('form[action*="/cart"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('[data-atc-banner]') || f.closest('.atc-banner--container')) { continue; }
      /* Empire ha due pulsanti checkout: uno nella testata del carrello (.cart-title) e uno nel riepilogo (.cart-checkout).
         Si usa quello del riepilogo (ultimo), mai quello nella testata: lì il blocco verrebbe schiacciato nel flex. */
      var btns = Array.prototype.slice.call(f.querySelectorAll('button[name="checkout"], input[name="checkout"]')).filter(function (b) { return !b.closest('.cart-title, header'); });
      var btn = btns.length ? btns[btns.length - 1] : null;
      if (!btn) { continue; }
      var target = btn.closest('.cart-checkout') || ((btn.parentElement && btn.parentElement !== f) ? btn.parentElement : btn);
      target.parentNode.insertBefore(root, target);
      return;
    }
  }

  function intercettaSubmit() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) { return; }
      var sub = e.submitter;
      var isCheckout = (sub && sub.name === 'checkout') || /\/checkout/.test(form.getAttribute('action') || '');
      if (!isCheckout) { return; }
      var ris = ultimoRisultato || validaStato(stato);
      if (!ris.ok) {
        e.preventDefault();
        toccati._tutti = true;
        aggiorna(null);
        var pagina = istanze.filter(function (i) { return i.mode === 'page'; })[0];
        if (pagina) {
          pagina.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var primoErr = pagina.root.querySelector('[aria-invalid="true"]') || pagina.root.querySelector('[data-ag-tipo]');
          if (primoErr) { primoErr.focus({ preventScroll: true }); }
        } else {
          // siamo nel cassetto senza blocco pagina: andiamo al carrello
          window.location.href = cfg.cartUrl + '#argoing-fattura';
        }
        return;
      }
      // dati validi: assicuriamoci che il salvataggio sia concluso prima di passare al checkout
      var firma = JSON.stringify(ris.attributi);
      if (firma !== ultimoSalvato) {
        e.preventDefault();
        if (sub) { sub.disabled = true; sub.classList.add('is-attesa'); }
        salvaAttributi(ris.attributi).then(function () {
          // inoltro effettivo: aggiungiamo il campo checkout e inviamo
          if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
            var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '';
            form.appendChild(h);
          }
          if (sub) { sub.disabled = false; sub.classList.remove('is-attesa'); }
          HTMLFormElement.prototype.submit.call(form);
        });
      }
    }, true);

    // link diretti al checkout (es. a[href*="/checkout"]) fuori dai form
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
      if (!a) { return; }
      var ris = ultimoRisultato || validaStato(stato);
      if (!ris.ok) {
        e.preventDefault();
        toccati._tutti = true; aggiorna(null);
        window.location.href = cfg.cartUrl + '#argoing-fattura';
      }
    }, true);
  }

  var inizializzato = false;
  function init(opzioni) {
    if (inizializzato) { return; }
    var roots = $$('[data-argoing-fattura]');
    if (!roots.length) { return; }
    inizializzato = true;
    if (opzioni) { Object.keys(opzioni).forEach(function (k) { cfg[k] = opzioni[k]; }); }
    var server = leggiDatiServer();
    if (server.cartUpdateUrl) { cfg.cartUpdateUrl = server.cartUpdateUrl; }
    if (server.cartUrl) { cfg.cartUrl = server.cartUrl; }

    // Priorità: attributi già nel carrello > memoria locale > dati del cliente loggato
    var daCart = statoDaAttributi(server.attributes);
    var daLS = leggiLS();
    if (daCart) { Object.assign(stato, daCart); ultimoSalvato = JSON.stringify(validaStato(stato).attributi); }
    else if (daLS) { Object.keys(stato).forEach(function (k) { if (typeof daLS[k] === 'string') { stato[k] = daLS[k]; } }); }
    if (server.customer) {
      var c = server.customer;
      if (!stato.cell && c.phone) {
        var tel = String(c.phone).replace(/[\s.\-\/]/g, '');
        var m = tel.match(/^(\+\d{1,3}|0039)?(\d{9,10})$/);
        if (m) { stato.pre = (m[1] && m[1] !== '0039') ? m[1] : '+39'; stato.cell = m[2]; }
      }
      if (!stato.rs && c.company) { stato.rs = c.company; }
    }
    if (!stato.pre) { stato.pre = '+39'; }

    roots.forEach(function (root) {
      posizionaNelCarrello(root);
      var ist = creaIstanza(root);
      istanze.push(ist);
      popolaIstanza(ist);
      collegaIstanza(ist);
    });
    intercettaSubmit();
    aggiorna(null);

    // Il cassetto Empire viene aperto dopo l'aggiunta al carrello: se il DOM del banner
    // viene rigenerato, ri-colleghiamo eventuali nuovi blocchi.
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        var nuovi = $$('[data-argoing-fattura]').filter(function (r) {
          return !istanze.some(function (i) { return i.root === r; });
        });
        if (nuovi.length) {
          nuovi.forEach(function (root) { var ist = creaIstanza(root); istanze.push(ist); popolaIstanza(ist); collegaIstanza(ist); });
          aggiorna(null);
        } else {
          // pulsanti checkout nuovi (es. banner aperto ora)
          if (ultimoRisultato) { aggiornaPulsanti(ultimoRisultato); }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (location.hash === '#argoing-fattura') {
      var pagina = istanze.filter(function (i) { return i.mode === 'page'; })[0];
      if (pagina) { setTimeout(function () { pagina.root.scrollIntoView({ block: 'center' }); }, 100); }
    }
  }

  return {
    init: init,
    verificaCodiceFiscale: verificaCodiceFiscale,
    verificaPartitaIVA: verificaPartitaIVA,
    verificaCellulare: verificaCellulare,
    verificaSDI: verificaSDI,
    verificaPEC: verificaPEC,
    verificaRagioneSociale: verificaRagioneSociale,
    cfCarattereControllo: cfCarattereControllo,
    pivaCifraControllo: pivaCifraControllo,
    validaStato: validaStato,
    _stato: function () { return stato; }
  };
}));
